import { render, staticRenderFns } from "./ExerciseDetail.vue?vue&type=template&id=62c467c8&scoped=true&"
import script from "./ExerciseDetail.vue?vue&type=script&lang=js&"
export * from "./ExerciseDetail.vue?vue&type=script&lang=js&"
import style0 from "./ExerciseDetail.vue?vue&type=style&index=0&id=62c467c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c467c8",
  null
  
)

export default component.exports